import React from 'react'

import { IconClose } from 'components/Zui/Icon'
import { ScrollableDirective } from 'components/Zui'

function Imprint({ onClose }) {
    return (
        <>
            <div className="settings-wrapper">
                <div className="setting-header-wrapper">
                    <div className="setting-header-title">
                        <span>Imprint</span>
                    </div>
                    <div className="close-setting-wrapper" onClick={onClose}>
                        <div className="user-settings-close-button">
                            <IconClose size="m" className="close-setting-icon" />
                        </div>
                    </div>
                </div>
                <div className="legal-details-wrapper">
                    <ScrollableDirective style={{ maxHeight: '100%' }}>
                        <div className="legal-content-wrapper">
                            <div className="legal-content-container">
                                {/* <div className="content-heading">
                                    <span>Terms of Use ZEISS FORUM Cloud Services</span>
                                </div> */}
                                <div className="company-title">
                                    <span>Carl Zeiss Meditec AG</span>
                                </div>
                                <div className="legal-content-container">
                                    <div className="license-details">
                                        <div className="license-content">
                                            Göschwitzer Straße 51-52
                                        </div>
                                        <div className="license-content">07745 Jena, Germany</div>
                                    </div>
                                    <div className="license-details">
                                        <div className="license-content">Phone: +49 3641 220-0</div>
                                        <div className="license-content">
                                            info.meditec@zeiss.com
                                        </div>
                                    </div>
                                    <div className="license-details">
                                        <div className="license-content">
                                            Chairman of the Supervisory Board: Dr. Karl Lamprecht
                                        </div>
                                        <div className="license-content">
                                            Management Board: Dr. Markus Weber (President &#38;
                                            CEO),
                                        </div>
                                        <div className="license-content">
                                            Justus Felix Wehmer (CFO), Jan Willem de Cler
                                        </div>
                                    </div>
                                    <div className="license-details">
                                        <div className="license-content">
                                            Commercial register: Jena, HRB 205 623
                                        </div>
                                        <div className="license-content">
                                            VAT REG No: DE811 922 737
                                        </div>
                                    </div>
                                    <div className="legal-content">
                                        <div>
                                            The contents of this website may differ from the current
                                            status of approval of the products in your country.
                                            Please contact our regional representative for more
                                            information. Subject to change in design and scope of
                                            delivery and as a result of ongoing technical
                                            development.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollableDirective>
                </div>
            </div>
        </>
    )
}
export default Imprint
